export enum BUFFERING_STATES {
  /**
   * Indicates that the Player is actively buffering media
   */
  ACTIVE = 'active',
  /**
   * Indicates that the Player has enough buffers and is not currently buffering
   * The player is done with buffering if previously active
   */
  INACTIVE = 'inactive',
}

export enum SEEKING_STATES {
  /**
   * Indicates that the player is seeking Media Source to the requested position
   */
  ACTIVE = 'active',
  /**
   * Indicates that the player is not currently seeking.
   * The player is done with Seeking if previously active
   */
  INACTIVE = 'inactive',
}

/**
 * Represents the various states the
 */
export enum PLAYBACK_STATES {
  /**
   * Indicates that the player has no media to play and doesn't hold any resources
   */
  IDLE = 'idle',
  /**
   * Indicates that the player is loading
   * the initial media chunks (manifest, initialization chunks etc.,) required
   * to play the Media Source
   */
  LOADING = 'loading',
  /**
   * Indicates that the player has loaded all the resources needed to start
   * playback rendering
   */
  LOADED = 'loaded',
  /**
   * Indicates that the player has started rendering playback
   */
  STARTED = 'started',
  /**
   * Indicates that the player has paused rendering playback
   */
  PAUSED = 'paused',
  /**
   * Indicates that the player has stopped.
   */
  STOPPED = 'stopped',
}
